/** A settings save has one deadline across session acquisition and the write. */
export const SETTING_SAVE_TIMEOUT_MS = 30_000;

/** The write may have landed; keep the draft and reconcile without claiming failure. */
export class SettingSaveUnconfirmed extends Error {
  constructor() {
    super(`Saving got no answer within ${SETTING_SAVE_TIMEOUT_MS / 1000} seconds`);
    this.name = 'SettingSaveUnconfirmed';
  }
}

export function settingSave<T>(operation: (signal: AbortSignal) => Promise<T>): Promise<T> {
  const controller = new AbortController();
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new SettingSaveUnconfirmed());
      controller.abort();
    }, SETTING_SAVE_TIMEOUT_MS);
    Promise.resolve().then(() => operation(controller.signal)).then(
      value => { clearTimeout(timer); resolve(value); },
      (error: unknown) => { clearTimeout(timer); reject(error); },
    );
  });
}
